import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { Person } from '../../../../global/models/person-model';
import { PersonalInfoProps } from '../../models/account-info-epi-props';
import { RelationshipsState } from '../relationships/relationships-model';
import { getCurrentSpouse } from '../relationships/relationships-selectors';
import { SpouseDisplay } from '../relationships/components/spouse-display';
import { useSpouseInformation } from '../../hooks/useSpouseInfo';
import { getMaritalStatusText } from '../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { TcsmStates } from '../../../../root/tcsm-model';
import { DemographicAppKeys, DemographicsContext } from '../../../../global/models/demographics-model';

export function MaritalInfo() {
    const app = useContext(DemographicsContext);
    const label = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps?.labelSettingState?.epiContent);
    const personInfo = useSelector<TcsmStates, PersonalInfoProps>(state => state.epiProps?.personalInfoSettingState?.epiContent);
    const relationshipState = useSelector<TcsmStates, RelationshipsState>(state => state.relationships[app]);
    const currentSpouse = getCurrentSpouse(relationshipState.spouses);
    const person = useSelector<TcsmStates, Person>(state => state.personalInfo[app]?.currentPerson);
    const spousesLoaded = useSpouseInformation(person?.person_guid);

    if (!spousesLoaded) {
        return <p>...Loading</p>;
    }

    const description = app === DemographicAppKeys.arc ? personInfo?.maritalStatusDescriptionArc : personInfo?.maritalStatusDescription;
    return (

        <DividerSection removeDivider sectionText={label?.maritalStatusTitle} sectionDescription={description}>
            <ContentSpacer>
                <>
                    <p><strong>{label?.maritalStatusLabel}</strong></p>
                    <p>{getMaritalStatusText(person?.marital_status)}</p>
                </>
            </ContentSpacer>
           
            {
                currentSpouse ?
                    <>
                        <ContentSpacer>
                            <>
                                <p>{label?.currentSpouseLabel}</p>
                                <SpouseDisplay canAddEdit={false} spouse={currentSpouse} />
                            </>
                        </ContentSpacer>
                    </>
                    : null
            }
        </DividerSection>
    );
}
